import PointLayer from "./PointLayer";

export default class AdLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Ad', options = { scale: 0.05 });
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });

        const dealTime = new Date(info.dealTime).getTime();
        const nowTime = new Date().getTime();
        const alarmStatus = dealTime < nowTime;
        node.a({
            'time': info.dealTime,
            'timeColor': alarmStatus ? 'rgb(255,0,0)' : 'rgb(0,0,0)',
            'ht.dataSource': info.pictures,
            'ht.vertical': Math.random() > 0.5,
            'ht.offset': 0,
            'alarmStatus': alarmStatus
        });
        node.setDataBindings({
            "a": {
                "title": {
                    "id": "$zs3d_ad_title"
                },
            }
        });
        if (!this.alarmNodes) {
            this.alarmNodes = [];
        }
        if (alarmStatus) {
            this.alarmNodes.push(node);
        }
        if (!this.nodeOffset) {
            this.nodeOffset = {};
        }
        this.nodeOffset[info.id] = 0;
    }

    showLayer() {
        super.show();
        this.startLayerAnim();
    }

    hideLayer() {
        super.hide();
        this.stopLayerAnim();
    }

    startLayerAnim() {
        if (!this.adAnim) {
            const params = {
                delay: 2000,
                duration: 5000,
                easing: t => t,
                finishFunc: () => {
                    this.nodes.forEach(node => {
                        const info = node.a('properties');
                        this.nodeOffset[info.id] = node.a('ht.offset');
                    });
                    this.adAnim = ht.Default.startAnim(params);
                },
                action: v => {
                    this.nodes.forEach(node => {
                        const info = node.a('properties');
                        // node.a('ht.offset', this.nodeOffset[info.id] + 70 * v );
                        const ds = node.a('ht.vertical') ? 70 * v : 200 * v;
                        node.a('ht.offset', this.nodeOffset[info.id] + ds);
                    });
                }
            };
            this.adAnim = ht.Default.startAnim(params);
        }
        if (!this.alarmAnim) {
            this.alarmAnim = ht.Default.startAnim({
                interval: 10,
                frames: Infinity,
                action: () => {
                    this.alarmNodes.forEach(node => {
                        const currentValue = node.a('dashOffset') || 0;
                        node.a('dashOffset', currentValue + 1);
                    });
                }
            });

        }
    }

    stopLayerAnim() {
        if (this.adAnim) {
            this.adAnim.pause();
            this.adAnim = null;

            this.nodes.forEach(node => {
                const info = node.a('properties');
                this.nodeOffset[info.id] = 0;
                node.a('ht.offset', 0);
            });
        }
        if (this.alarmAnim) {
            this.alarmAnim.pause();
            this.alarmAnim = null;
        }
    }

}